import React, { Component, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';

// Elements
import BackToTop from './elements/back-top';
import PageScrollTop from './elements/page-scroll-top';

// Layout
import Header from './layout/header';
import Footer from './layout/footer';

// Eagerly loaded starting page
import Index from './pages/index';
import CallButton from './callUs';
import logo from '../images/logo.webp';

// Lazy load other pages
const AboutUs = React.lazy(() => import('./pages/about-1'));
const ContactUs = React.lazy(() => import('./pages/contact-1'));
const Services = React.lazy(() => import('./pages/service-1'));
const Services2 = React.lazy(() => import('./pages/service-2'));
const Error = React.lazy(() => import('./pages/error-404'));
const Otkup = React.lazy(() => import('./pages/otkup'));



// Custom hook to preload lazy components after 10 seconds
const usePreloadLazyComponents = (components) => {
	useEffect(() => {
		const timer = setTimeout(() => {
			components.forEach((factory) => {
				factory().then((module) => {
					// console.log(`Preloaded: ${module.default.name || 'Component'}`);
				}).catch((error) => {
					console.error(`Failed to preload component:`, error);
				});
			});
		}, 10000); // 10 seconds

		return () => clearTimeout(timer); // Cleanup on unmount
	}, [components]);
};

// Component to handle GA4 tracking and preloading
function AppWrapper() {
	// Preload all lazy components after 10 seconds
	usePreloadLazyComponents([
		() => import('./pages/about-1'),
		() => import('./pages/contact-1'),
		() => import('./pages/service-1'),
		() => import('./pages/service-2'),
		() => import('./pages/error-404'),
		() => import('./pages/otkup'),
	]);


	return (
		<Suspense fallback={<div className="loading"><img src={logo} alt='MajorMob' /></div>}>
			<Routes>
				<Route element={<ThemeLayout />}>
					{/* Eagerly loaded starting page */}
					<Route path="/" element={<Index />} />
					{/* Lazy-loaded pages */}
					<Route path="/info" element={<AboutUs />} />
					<Route path="/otkup" element={<Otkup />} />
					<Route path="/prodaja" element={<Services2 />} />
					<Route path="/servis" element={<Services />} />
					<Route path="/kontakt" element={<ContactUs />} />
				</Route>

				{/* Lazy-loaded 404 page */}
				<Route path="*" element={<Error />} />
			</Routes>
		</Suspense>
	);
}

class Markup extends Component {
	render() {
		return (
			<>
				<BrowserRouter basename="/">
					<AppWrapper />
					<PageScrollTop />
				</BrowserRouter>
				<BackToTop />
			</>
		);
	}
}

function ThemeLayout() {
	return (
		<>
			<Header />
			<CallButton />
			<Outlet />
			<Footer />
		</>
	);
}

export default Markup;